import qs from 'query-string';

export const parseLocationSearch = (locationSearch: string) => {
    return qs.parse(locationSearch, {
        parseNumbers: true,
        arrayFormat: 'bracket-separator',
        arrayFormatSeparator: '|',
    });
};